import { createAsyncThunk } from '@reduxjs/toolkit';
import { aiService, songService } from 'services/api';
import { NAMESPACE } from './constants';
import { RemixerSong } from './types';

const fetchSong = createAsyncThunk<
  RemixerSong,
  { id: string; isAIGenerated: boolean }
>(`${NAMESPACE}/fetchSong`, async ({ id, isAIGenerated }) => {
  if (isAIGenerated) {
    return aiService.getAIGeneratedSong({ id });
  }
  return songService.getSong(id);
});

export default fetchSong;
